<template>
  <div class="page-container">
    <div id="searchArea">
      <el-form class="el-form-filter" :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
        <div class="clearfix">
          <div class="fl pb10">
            <el-button type="primary" @click="addNew">Add Service</el-button>
            <!-- 导出 excel -->
            <el-button
              type="primary"
              plain
              size="small"
              icon="el-icon-download"
              :disabled="dataListSelections.length <= 0"
              :loading="batchDownBtnLoading"
              @click="handleExportExcel"
              v-if="isAuth('sys:module:download')"
            >
              Export Excel
            </el-button>
          </div>
          <div class="fr">
            <el-form-item>
              <el-select v-model="dataForm.country" filterable clearable placeholder="Country">
                <el-option v-for="item in countryList" :key="item.value" :label="item.title" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="dataForm.supplierId" clearable placeholder="Supplier" class="fluid-width">
                <el-option v-for="item in supplierList" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="dataForm.businessType" clearable placeholder="Business Type">
                <el-option v-for="item in businessTypes" :key="item.value" :label="item.title" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input v-model="dataForm.keyword" clearable placeholder="Description"></el-input>
            </el-form-item>
            <el-button icon="el-icon-search" type="primary" plain v-debounce @click="getDataList(1)">Search</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <div>
      <el-table max-height="680" :data="dataList" v-loading="dataListLoading" @selection-change="selectionChangeHandle" style="width: 100%">
        <el-table-column type="selection" align="center" width="50" fixed="left"></el-table-column>
        <el-table-column label="Code" prop="serviceCode" align="center" width="120"></el-table-column>
        <el-table-column label="Description" align="center" min-width="300">
          <template slot-scope="scope">
            <div class="lh16 fs13">{{ scope.row.description }}</div>
            <div class="lh16 fs12 grey">{{ scope.row.descriptionCn }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="Business Type"
          prop="businessTypeList"
          align="center"
          :formatter="businessTypeListFormat"
          min-width="300"
        ></el-table-column>
        <el-table-column label="Price" prop="serviceFee" align="center" min-width="120">
          <template slot-scope="scope">
            {{ currencyAndAmountFormat(scope.row.currency, scope.row.serviceFee) }}
          </template>
        </el-table-column>
        <el-table-column label="Original Price" prop="originalServiceFee" align="center" min-width="120">
          <template slot-scope="scope">
            {{ currencyAndAmountFormat(scope.row.currency, scope.row.originalServiceFee) }}
          </template>
        </el-table-column>
        <el-table-column label="Country" prop="country" align="center" min-width="140"></el-table-column>
        <el-table-column label="Supplier" prop="supplier.abbr" align="center" min-width="150"></el-table-column>
        <el-table-column label="Sort No." prop="orderNum" align="center" width="80"></el-table-column>
        <el-table-column label="Status" prop="status" align="center" width="90" :formatter="enableAndDisableFormat"></el-table-column>
        <el-table-column label="Update Time" prop="updateTime" align="center" width="164"></el-table-column>
        <el-table-column label="Action" align="center" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" class="fwb" @click="updateHandle(scope.row.id)">Edit</el-button>
            <el-button type="text" class="fwb" @click="deleteHandle(scope.row.id)" v-if="isAuth('sys:module:delete')">Delete</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :current="current"
        :pageSize="pageSize"
        :totalCount="totalCount"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import formatterMixin from "@/mixins/formatterMixin";
import paginationMixin from "@/mixins/paginationMixin.js";
import { downloadFile } from "@/utils";
import { mapState } from "vuex";
export default {
  mixins: [formatterMixin, paginationMixin],
  components: {
    Pagination,
  },
  data() {
    return {
      dataList: [],
      batchDownBtnLoading: false,
      dataListLoading: false,
      dataListSelections: [],
      dataForm: {
        country: "",
        supplierId: "",
        businessType: "",
        keyword: "",
      },
      supplierList: [],
    };
  },
  computed: {
    ...mapState("constant", ["countryList", "businessTypes"]),
    noContent() {
      return this.totalCount === 0;
    },
  },
  methods: {
    // 获取供应商列表
    getSupplierList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplier")
          .then(res => {
            if (res.code === 200) {
              this.supplierList = res.data || [];
              resolve();
            } else {
              this.$message.error(res.msg);
              reject();
            }
          })
          .catch(err => {
            console.error(err);
            reject();
          });
      });
    },
    // 获取分页数据
    async getDataList(current) {
      this.dataListLoading = true;
      if (current) {
        this.current = current;
      }
      const params = {
        current: this.current,
        size: this.pageSize,
        ...this.dataForm,
        "orders[0].asc": false,
        "orders[0].column": "id",
      };
      const { code, data } = await this.$http.get("/admin/service/page", {
        params,
      });
      if (code === 200) {
        this.dataList = data.records;
        this.totalCount = data.total;
      } else {
        this.dataList = [];
        this.totalCount = 0;
      }
      this.dataListLoading = false;
    },
    // 新建
    addNew() {
      this.$router.push("/sys/pkg/module/add");
    },
    // 编辑
    updateHandle(id) {
      this.$router.push(`/sys/pkg/module/${id}/edit`);
    },
    // 删除
    deleteHandle(id) {
      this.$confirm(`Delete this service. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(async () => {
        const { code, msg } = await this.$http.post(
          `/admin/service/delete`,
          {},
          {
            params: {
              "ids[]": id,
            },
          },
        );
        if (code === 200) {
          this.$message({
            message: "success",
            type: "success",
            duration: 1500,
            onClose: () => {
              // mixins
              this.singleDataDelete();
              this.getDataList();
            },
          });
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    // 导出excel
    async handleExportExcel() {
      const ids = this.dataListSelections.map(item => item.id);
      this.batchDownBtnLoading = true;
      this.$http
        .get("/admin/service/export", {
          params: { ids },
          responseType: "blob",
        })
        .then(res => {
          downloadFile(res);
        })
        .finally(() => {
          this.batchDownBtnLoading = false;
        });
    },
  },
  activated() {
    this.getSupplierList();
    this.getDataList();
  },
};
</script>
<style lang="scss" scoped>
.plan-modules-wrapper {
  .relative {
    border: none;
    background: #f9fafd;
    .module-item {
      padding: 18px 20px 18px;
      display: flex;
      align-items: center;
      overflow: hidden;
      flex-wrap: nowrap;
      border: 2px dashed #e9ecf1;
      border-bottom: none;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;

      .module-desc {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        overflow: hidden;
        font-size: 16px;

        .item-label {
          display: inline-block;
          width: 60px;
          color: #7987a0;
          font-size: 14px;
          margin-right: 10px;
        }
        .item-wrap {
          line-height: 38px;
          margin: 0px;
        }
        .item-content {
          font-size: 14px;
          font-weight: bold;
          color: #011a45;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          word-break: break-all;
          display: inline-block;
          width: calc(100% - 70px);
          vertical-align: middle;
        }
        .date {
          margin: 24px 0 10px;
          font-size: 14px;
        }
      }
    }
    .el-card-actions {
      border: 2px dashed #e9ecf1;
      border-top: 2px solid #e9ecf1;
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
      background: transparent;
    }

    .el-card-actions li:not(:last-child) {
      border-right: 2px solid #e9ecf1;
    }
  }

  .relative:hover {
    background: #e8f0ff;
    .module-item {
      border-color: #e8f0ff;
    }
    .el-card-actions {
      border-color: #e8f0ff;
      border-top: 2px solid #d8e3ff;
    }
    .el-card-actions li:not(:last-child) {
      border-right: 2px solid #d8e3ff;
    }
  }
}
</style>
